<template>
	<v-container fill-height class="mx-auto">
		<v-layout row wrap align-center>
			<v-flex class="text-center">
				<v-card
					class="mx-auto"
					max-width="900"
					max-height="800"
					:loading="loading_col"
				>
					<v-row>
						<v-col
							cols="12"
							sm="6"
							align="center"
							justify="center"
							fill-height
							class="pa-2 d-none d-md-flex d-lg-flex d-xl-flex"
							:elevation="10"
							:style="{ 'background-color': bg_color }"
						>
							<v-img
								class="white--text align-end ma-10 ml-5"
								src="../assets/login-art-alt.svg"
								v-show="show_login"
							>
							</v-img>
						</v-col>

						<v-col cols="12" md="6" class="text-left px-10 py-10 form">
							<!--Login-->
							<v-main v-show="show_login">
								<v-card-title class="pl-0">Sign in to Simplelearn</v-card-title>
								<v-main class="py-3 pr-4">
									<v-card-text class="pb-4 pl-0 pt-0">
										Start developing your skills.
									</v-card-text>
									<v-form>
										<v-text-field
											label="Email"
											placeholder="Username or Email Address"
											v-model="form.login.email"
											:rules="[
												v => !!v || 'Username or Email Address is required',
											]"
											required
											solo
											@keydown.enter="login"
										></v-text-field>
										<v-text-field
											name="Password"
											label="Password"
											v-model="form.login.password"
											placeholder="Password"
											:append-icon="
												show_password ? 'visibility' : 'visibility_off'
											"
											@click:append="() => (show_password = !show_password)"
											:type="show_password ? 'password' : 'text'"
											:rules="[v => !!v || 'Password is required']"
											required
											solo
											@keydown.enter="login"
										></v-text-field>
									</v-form>

									<v-row>
										<v-col>
											<v-btn
												class="white--text mt-2 text-capitalize"
												:color="theme.primary"
												:disabled="loading"
												@click="login"
												width="200"
												depressed
											>
												Sign in
											</v-btn>
										</v-col>
										<v-col class="pt-6">
											<a
												class="forgot-password"
												@click="
													if (loading == false) {
														show_forgot_password = true
													}
												"
												>Forgot password?</a
											>
										</v-col>
									</v-row>
									<v-main class="pt-10 my-2 font-small">
										Don't have an account?
										<v-col class="pa-0 pt-2">
											<v-btn
												class="mt-2 text-capitalize white--text"
												:color="theme.accent"
												:disabled="loading"
												@click="beginSignup"
												block
												depressed
												link
											>
												Sign up now
											</v-btn>
										</v-col>
									</v-main>
									<v-col class="pt-2 mx-0 px-0">
											<a
												class="test-login"
												@click="
													if (loading == false) {
														form.login.email = 'enoch'
														form.login.password = 'password'
														login()
													}
												"
												>Sign in as a test Student</a
											>
											<br />
											<a
												class="test-login"
												@click="
													if (loading == false) {
														form.login.email = 'enochadmin'
														form.login.password = 'password'
														login()
													}
												"
												>Sign in as a test Teacher</a
											>
										</v-col>
								</v-main>
							</v-main>

							<!-- Register -->
							<v-main v-show="show_register">
								<v-icon
									:disabled="loading"
									class="back-btn"
									@click="show_register = false"
									>mdi-chevron-left</v-icon
								>
								<v-card-title class="pl-0"
									>Sign up for Simplelearn</v-card-title
								>
								<v-main class="py-3 pr-4">
									<v-text-field
										label="Full name"
										placeholder="Full name"
										v-model="form.register.name"
										solo
									></v-text-field>
									<v-text-field
										label="Email"
										placeholder="Email"
										v-model="form.register.email"
										solo
									></v-text-field>
									<v-row>
										<v-col>
											<v-select
												:cols="8"
												:items="schools"
												item-text="name"
												item-value="id"
												label="School"
												placeholder="School"
												v-model="form.register.school_id"
												solo
											></v-select>
										</v-col>
										<v-col>
											<v-select
												:cols="4"
												:items="Array.from(Array(8).keys()).map(i => i + 5)"
												label="Grade"
												placeholder="Grade"
												v-model="form.register.grade"
												solo
											></v-select>
										</v-col>
									</v-row>
									<v-row>
										<v-col>
											<v-btn
												class="white--text mt-2 text-capitalize"
												:color="theme.primary"
												:disabled="loading || cannot_proceed"
												@click="
													show_register_next = true
													show_register = false
												"
												width="200"
												depressed
											>
												Proceed
											</v-btn>
										</v-col>
									</v-row>
									<v-main class="pt-10 my-2 font-small">
										Already have an account?
										<a class="forgot-password" @click="show_register = false"
											>Sign in</a
										>
									</v-main>
								</v-main>
							</v-main>

							<!-- Register II -->
							<v-main v-show="show_register_next">
								<v-icon
									:disabled="loading"
									class="back-btn"
									@click="
										show_register_next = false
										show_register = true
									"
									>mdi-chevron-left</v-icon
								>
								<v-card-title class="pl-0"
									>Sign up for Simplelearn</v-card-title
								>
								<v-main class="py-3 pr-4">
									<v-text-field
										label="Username"
										placeholder="Username"
										v-model="form.register.username"
										solo
									></v-text-field>
									<template>
										<v-file-input
											:rules="[
												value =>
													!value ||
													value.size < 500000 ||
													'Image size should be less than 500KB',
											]"
											accept="image/*"
											show-size
											placeholder="Set profile picture"
											v-model="form.register.image"
											solo
										></v-file-input>
									</template>
									<v-text-field
										name="password"
										v-model="form.register.password"
										label="Password"
										placeholder="Password"
										:append-icon="
											show_password_register ? 'visibility' : 'visibility_off'
										"
										@click:append="
											() => (show_password_register = !show_password_register)
										"
										:type="show_password_register ? 'password' : 'text'"
										solo
									></v-text-field>
									<v-text-field
										name="password"
										v-model="form.register.confirm_password"
										label="Confirm Password"
										placeholder="Confirm Password"
										:append-icon="
											show_confirm_password_register
												? 'visibility'
												: 'visibility_off'
										"
										@click:append="
											() =>
												(show_confirm_password_register = !show_confirm_password_register)
										"
										:type="show_confirm_password_register ? 'password' : 'text'"
										:rules="[
											v =>
												v == this.form.register.password ||
												'Passwords don\'t match',
										]"
										required
										solo
									></v-text-field>
									<v-row>
										<v-col>
											<v-btn
												class="white--text mt-2 text-capitalize"
												:color="theme.primary"
												:disabled="loading || cannot_signup"
												@click="register"
												width="200"
												depressed
											>
												Sign up
											</v-btn>
										</v-col>
									</v-row>
								</v-main>
							</v-main>

							<v-main v-if="show_register || show_register_next">
								<v-stepper>
									<v-stepper-header>
										<v-stepper-step
											class="font-tiny"
											:complete="show_register_next"
											step="1"
										></v-stepper-step>

										<v-divider></v-divider>

										<v-stepper-step
											:complete="cannot_signup == false"
											step="2"
										></v-stepper-step>
									</v-stepper-header>
								</v-stepper>
							</v-main>

							<!--Forgot password-->
							<v-main v-show="show_forgot_password">
								<v-icon
									:disabled="loading"
									class="back-btn"
									@click="
										show_register = false
										show_forgot_password = false
									"
									>mdi-chevron-left</v-icon
								>
								<v-card-title class="pl-0">Forgot password</v-card-title>
								<v-main class="py-3 pr-4 pt-1">
									<v-card-text class="pb-4 pl-0">
										Enter the email address you used when you joined and we’ll
										send you instructions to reset your password
									</v-card-text>
									<v-card-text class="pb-10 pl-0 pt-0">
										For security reasons, we do NOT store your password. So be
										rest assured that we will never send your password via
										email.
									</v-card-text>

									<v-text-field
										label="Email"
										placeholder="Email"
										v-model="form.recover.email"
										solo
										@keydown.enter="reset"
									></v-text-field>

									<v-row>
										<v-col>
											<v-btn
												class="white--text mt-2 text-capitalize"
												:color="theme.primary"
												:disabled="cannot_recover"
												@click="reset"
												width="210"
												depressed
											>
												Send reset instructions
											</v-btn>
										</v-col>
									</v-row>
								</v-main>
							</v-main>
						</v-col>
					</v-row>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
	name: 'Login',

	data: () => ({
		form: {
			login: {
				email: null,
				password: null,
			},
			register: {
				name: null,
				email: null,
				password: null,
				confirm_password: null,
				school_id: null,
				grade: null,
				image: null,
				username: null,
			},
			recover: {
				email: null,
			},
		},
		schools: [],
		show_forgot_password: false,
		show_register: false,
		show_register_next: false,
		show_password: String,
		show_confirm_password_register: String,
		show_password_register: String,
	}),
	mounted() {
		if (this.user) this.$router.push({ name: 'Dashboard' })
	},
	methods: {
		...mapMutations(['completeLogin', 'setAlert']),
		login() {
			this.core.http
				.post('auth/login', this.form.login)
				.then(response => {
					this.completeLogin(response.data)
					this.$router.push({ name: 'Dashboard' })
				})
				.catch(error => {
					this.setAlert(error.response)
				})
		},
		beginSignup() {
			this.core.http
				.get('schools')
				.then(response => {
					this.schools = response.data.schools
				})
				.catch(error => {
					this.setAlert(error.response)
				})
			this.show_register = true
		},
		register() {
			const data = new FormData()
			Object.keys(this.form.register).forEach(key => {
				const value = this.form.register[key]
				if (key != 'image') data.append(key, value)
			})
			if (this.form.register.image != null)
				data.append('image', this.form.register.image)
			this.core.http
				.post('auth/register', data)
				.then(response => {
					this.completeLogin(response.data)
					this.$router.push({ name: 'Dashboard' })
				})
				.catch(error => {
					this.setAlert(error.response)
				})
		},
		reset() {
			this.core.http
				.post('auth/reset', this.form.recover)
				.then(response => {
					this.setAlert(response)
				})
				.catch(error => {
					this.setAlert(error.response)
				})
		},
	},
	computed: {
		...mapGetters(['theme', 'user', 'loading']),
		loading_col: function() {
			if (this.loading) return this.theme.accent
			else return false
		},
		cannot_proceed: function() {
			return (
				this.form.register.name == null ||
				this.form.register.email == null ||
				this.form.register.school_id == null ||
				this.form.register.grade == null
			)
		},
		cannot_signup: function() {
			return (
				this.form.register.username == null ||
				this.form.register.password == null ||
				this.form.register.confirm_password == null
			)
		},
		cannot_recover: function() {
			return this.form.recover.email == '' || this.form.recover.email == null
		},
		bg_color: function() {
			if (this.show_register || this.show_register_next)
				return this.theme.dark ? this.theme.primary : this.theme.tertiary
			if (this.show_forgot_password) return this.theme.accent
			return '#fff'
		},
		show_login: function() {
			return (
				this.show_forgot_password == false &&
				this.show_register == false &&
				this.show_register_next == false
			)
		},
	},
}
</script>

<style scoped>
.forgot-password, .test-login {
	vertical-align: middle;
	line-height: 20px;
	font-size: 0.9rem;
}
.v-input__icon--append .v-icon {
	color: red;
}
.back-btn {
	padding: 5px;
	border: 1px solid lightgrey;
	border-radius: 50%;
}
</style>
